/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { RemoveScroll } from 'react-remove-scroll';

import { ThemeProvider } from 'emotion-theming';
import IChatOptions from '../../interfaces/IChatOptions';
import ChatArea from '../ChatArea';
import WorkArea from '../WorkArea';

export interface IWidgetProps {
  options: IChatOptions;
}

export interface IInjectedProps extends IWidgetProps { }

class Widget extends Component<IWidgetProps> {
  protected get injected(): IInjectedProps {
    return this.props as IInjectedProps;
  }

  public render() {
    const { expanded = false } = this.props.options;

    const theme = {
      ...this.props.options,
    };

    return (
      <ThemeProvider theme={theme}>
        <RemoveScroll allowPinchZoom={true} noIsolation={true} removeScrollBar >
          <div className='Widget-content'>
            {expanded && (
              <div>
                <WorkArea options={this.props.options} />
              </div>
            )}
            <div
              className={'css-1ms0frb' + (expanded ? '' : ' compact')}
              style={{ width: '100%', height: '100%' }}
            >
              <ChatArea isWidget={true} options={this.props.options} />
            </div>
          </div>
        </RemoveScroll>
      </ThemeProvider>
    );
  }
}

export default Widget;
